/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_BannedInputs */

const fr_account_audit_banned = /** @type {(inputs: Account_Audit_BannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte bloqué`)
};

/**

* @param {Account_Audit_BannedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_banned = /** @type {((inputs?: Account_Audit_BannedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_BannedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_banned(inputs)
});